import React, { createContext, useCallback, useState } from 'react'
import { WrapAssessmentDefs, WrapCreateSet, WrapContent } from './Style'
import { AssessmentDefs } from 'pages'
import { CustomSection } from 'styles/GlobalStyle'
import { AssessmentDefDrawer } from 'pages/School/AssessmentDef'
import CreateSet from './CreateSet'

export const SelectAssessmentsContext = createContext()

const CreateAssessments = (props) => {
    const [currentAssessmentDef, setCurrentAssessmentDef] = useState(null)
    const [openAssesmentDefDrawer, setOpenAssesmentDefDrawer] = useState(false)

    const { customFilters, showBattery, assessmentFilters, setAssessmentFilters, assessmentDefs, selectedAssessmentDefs, setSelectedAssessmentDefs } = props

    const openAssessmentDefDrawer = useCallback((ass) => {
        setOpenAssesmentDefDrawer(true)
        setCurrentAssessmentDef(ass.id)
    }, [])

    return (
        <SelectAssessmentsContext.Provider value={props}>
            <WrapContent>
                <WrapAssessmentDefs>
                    <AssessmentDefs
                        setAssessmentFilters={setAssessmentFilters}
                        assessmentFilters={assessmentFilters}
                        selectedAssessmentDefs={selectedAssessmentDefs}
                        setSelectedAssessmentDefs={setSelectedAssessmentDefs}
                        headerFilters={customFilters}
                        onSelectAssessment={openAssessmentDefDrawer} // איזה פעולה תתרחש בעת לחיצה על מבדק
                        selectAssessment // האם לאפשר בחירה של מבדק/ים
                        multiple  // האם לאפשר בחירת מבדקים מרובה
                        showBattery={showBattery} // האם להציג נתונים הקשורים לסוללה
                    />
                </WrapAssessmentDefs>
                <WrapCreateSet>
                    <CustomSection $bg>
                        <CreateSet {...props} />
                    </CustomSection>
                </WrapCreateSet>
                <AssessmentDefDrawer
                    open={openAssesmentDefDrawer}
                    handleDrawer={setOpenAssesmentDefDrawer}
                    assessmentDefId={currentAssessmentDef}
                />
            </WrapContent>
        </SelectAssessmentsContext.Provider>
    )
}

export default CreateAssessments